import Bloqueo from '@pages/operadora-loteria/bloqueo';

export default [
    {
        path: '/operadora-loteria/bloqueo',
        name: 'operadora-loteria.bloqueo',
        component: Bloqueo,
    },
];